import { render, staticRenderFns } from "./AlertOctagonOutline.vue?vue&type=template&id=642b9664"
import script from "./AlertOctagonOutline.vue?vue&type=script&lang=js"
export * from "./AlertOctagonOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports